// extracted by mini-css-extract-plugin
module.exports = {"AppCreateButtonCreateVpcLink":"AppCreateButtonCreateVpcLink_kHwKv","AppCreateButtonButton":"AppCreateButtonButton_ONSI6"};